import CheckCircleOutlineIcon from "@atlaskit/icon/glyph/check-circle-outline";
import WarningIcon from "@atlaskit/icon/glyph/warning";
import Spinner from "@atlaskit/spinner";

import { FormattedMessageProps } from "../../messages";

export const IsValidOrLoading = ({
    isValidating,
    siteNameValue,
    validationMessage
}: {
    isValidating: boolean;
    siteNameValue: string;
    validationMessage?: FormattedMessageProps;
}) => {
    if (siteNameValue === "") {
        return null;
    }
    if (isValidating) {
        return <Spinner size="small" testId="spinner" />;
    }
    if (validationMessage) {
        return <WarningIcon label="warning" primaryColor="#DE350B" />;
    }
    return <CheckCircleOutlineIcon label="success" primaryColor="#36B37E" />;
};
